import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import toaster from 'utils/toaster';
import { TOAST_CONFIG } from '../constants';
import css from './QuestionField.css';

const QuestionField = ({ question, maxLength, value, onChange }) => {
    const handlePaste = e => {
        if (!maxLength) return;
        const pasted = e.clipboardData.getData('text');
        const { selectionStart, selectionEnd } = e.target;
        const selectionLength = selectionEnd - selectionStart;
        const projectedLength = (value || '').length - selectionLength + pasted.length;
        if (projectedLength > maxLength) {
            toaster.warning(`Pasted text was truncated to fit the ${maxLength} character limit.`, TOAST_CONFIG);
        }
    };

    return (
        <div className={css.question}>
            <div className={css.header}>
                <div className={css.title}>{question.title}</div>
                <div className={css.description}>{question.description}</div>
            </div>
            <textarea
                className={css.textarea}
                placeholder={question.placeholder}
                value={value || ''}
                maxLength={maxLength}
                onChange={e => onChange(question.id, e.target.value)}
                onPaste={handlePaste}
            />
            <div
                className={classNames(css.charCount, {
                    [css.charCountLimit]: maxLength && (value || '').length >= maxLength,
                })}
            >
                {(value || '').length}
                {maxLength ? ` / ${maxLength}` : ''} characters
            </div>
        </div>
    );
};

QuestionField.propTypes = {
    question: PropTypes.shape({
        id: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        placeholder: PropTypes.string,
    }).isRequired,
    maxLength: PropTypes.number,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
};

export default QuestionField;
